import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";

export const StyledActionIconButton = styled(IconButton)(({ theme }) => ({
  "& .hover": {
    backgroundColor: "red"
  },
  padding: "5px",
  borderRadius: "25px",
  "& svg": {
    fontSize: "0.5em"
  },
  "& p": {
    fontSize: "0.8125rem",
    marginLeft: "5px"
  }
}));